import React, { useEffect } from 'react';
import '../styles/almalinux10.css';

const CheckIcon = () => (
  <svg className="check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 001.414 0l8-8a1 1 000-1.414z" clipRule="evenodd" />
  </svg>
);

const plans = [
  {
    name: "AlmaLinux 10 Bronze",
    discount: "UPDATED",
    price: "$7.99",
    subtitle: "Next-gen AlmaLinux VPS with modern packages.",
    features: [
      "VPS | AlmaLinux 10 LTS x64",
      "32+ Regions",
      "1 vCPU",
      "2GB Ram",
      "55GB NVMe SSD",
      "2Tb Bandwidth",
      "IPv4 + IPv6",
      "Full root access",
      "Daily Backups",
      "Free Daily Backups",
      "Top Tier-1 Data Center Network",
      "Certified Hosting Infrastructure",
      "Unlimited Free SSL",
    ],
  },
  {
    name: "AlmaLinux 10 Silver",
    discount: "OPTIMIZED",
    price: "$13.99",
    subtitle: "Great for control panels and LEMP/LAMP stacks.",
    features: [
      "VPS | AlmaLinux 10 LTS x64",
      "32+ Regions",
      "2 vCPU",
      "4GB Ram",
      "80GB NVMe SSD",
      "3Tb Bandwidth",
      "IPv4 + IPv6",
      "Full root access",
      "Daily Backups",
      "Free Daily Backups",
      "Top Tier-1 Data Center Network",
      "Certified Hosting Infrastructure",
      "Unlimited Free SSL",
    ],
  },
  {
    name: "AlmaLinux 10 Gold",
    discount: "PREMIUM",
    price: "$39.99",
    subtitle: "Best performance for enterprise workloads.",
    features: [
      "VPS | AlmaLinux 10 LTS x64",
      "32+ Regions",
      "4 vCPU",
      "8GB Ram",
      "160GB NVMe SSD",
      "4Tb Bandwidth",
      "IPv4 + IPv6",
      "Full root access",
      "Daily Backups",
      "Free Daily Backups",
      "Top Tier-1 Data Center Network",
      "Certified Hosting Infrastructure",
      "Unlimited Free SSL",
    ],
  },
];

function Almalinux10() {
  useEffect(() => {
    document.body.classList.add('almalinux10-page');
    return () => {
      document.body.classList.remove('almalinux10-page');
    };
  }, []);

  return (
    <div className="pricing-section">
      <div className="pricing-wrapper">
        {plans.map((plan, index) => (
          <div className="pricing-card" key={index}>
            <div className="discount-badge">{plan.discount}</div>
            <h2>{plan.name}</h2>
            <p className="plan-subtitle">{plan.subtitle}</p>
            <p className="plan-price">
              <span className="price-label">Starting from</span><br />
              <span className="price-amount">{plan.price}<span className="per-month">/1st mo</span></span>
            </p>
            <a href="https://account.i-word.net/order/config/preconfig/vps_almalinux_10" className="start-btn" target="_blank" rel="noopener noreferrer">START NOW</a>
            <div className="divider"></div>
            <ul className="feature-list">
              {plan.features.map((feature, i) => (
                <li key={i}><CheckIcon /> {feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Almalinux10;
